export const parsePhone = (value) => {
    if (!value) {
        return value;
    }
    const digits = value.replace(/[^\d]/g, '');
    const PHONE_LENGTH = 11;
    let phone = (digits.length > PHONE_LENGTH) ? digits.substring(0, PHONE_LENGTH) : digits;
    phone = phone.replace(/(\d)/, "($1");
    phone = phone.replace(/(\d{2})(\d)/, "$1) $2");
    phone = phone.replace(/(\d{5})(\d)/, "$1-$2");
    return phone;
}

export const parseZipCode = (value) => {
    if (!value) {
        return value;
    }
    const ZIP_CODE_LENGTH = 8;
    const digits = value.replace(/[^\d]/g, '');
    let zip_code = (digits.length > ZIP_CODE_LENGTH) ? digits.substring(0, ZIP_CODE_LENGTH) : digits;
    zip_code = zip_code.replace(/(\d{5})(\d)/, "$1-$2");
    return zip_code;
}


// WEBPACK FOOTER //
// ./src/components/Pages/Establishments/Management/parser.js